/* Storefront sticky cart/upsell bar.
   LEFT column: hub-and-spoke rotating message area (WhatsApp anchor + spokes), vertical swaps.
   RIGHT column: cart subtotal hero ("In cart $X") + a gap line beneath it, live from the cart;
   the right column taps through to the cart. Empty cart => whole bar hidden. Loaded once (guarded).

   Cart states (right-column gap line):
     A  subtotal < $200            -> "Add $X to reach the $200 minimum"
     B  $200 <= subtotal < $1,500  -> "$X to your next discount" (next tier above the subtotal)
     C  subtotal >= $1,500         -> "✓ Best price unlocked · 6% off your whole order" (yellow)
   Subtotal basis = sum of original_line_price (pre-discount), same as the product-card tier table. */
(function () {
  if (window.__upsellBarInit) return;
  window.__upsellBarInit = true;

  // --- Keep the sticky bar flush under the header -----------------------------------------
  // Dawn only refreshes --header-height on connect and the 990px breakpoint, so it goes stale on
  // webfont-load / desktop reflow and the bar drifts into a gap. A ResizeObserver keeps our own
  // --sf-header-height (the bar's sticky offset) exact on every real header change.
  function syncHeaderHeight() {
    var header = document.querySelector('.header');
    if (!header) return false;
    function set() { document.documentElement.style.setProperty('--sf-header-height', header.offsetHeight + 'px'); }
    set();
    if (window.ResizeObserver) { try { new ResizeObserver(set).observe(header); } catch (e) {} }
    window.addEventListener('resize', set);
    window.addEventListener('load', set);
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) { document.fonts.ready.then(set).catch(function () {}); }
    return true;
  }
  if (!syncHeaderHeight()) document.addEventListener('DOMContentLoaded', syncHeaderHeight);

  var pending = null;

  // Tier ladder + minimum come from the bar's data-* attrs (the Fusion-synced onarys/volume_tiers
  // metafield, rendered in Liquid), with a hardcoded fallback. Read per bar so it mirrors what the
  // section rendered.
  function cfgFor(bar) {
    var tiers = (bar.getAttribute('data-tiers') || '350,500,1000,1500').split(',')
      .map(function (x) { return Math.round(parseFloat(x) * 100); })
      .filter(function (n) { return n > 0; });
    if (!tiers.length) tiers = [35000, 50000, 100000, 150000];
    var min = Math.round(parseFloat(bar.getAttribute('data-minimum') || '200') * 100) || 20000;
    return { tiers: tiers, min: min, top: tiers[tiers.length - 1] };
  }

  // Gap amounts in the message: cents only when non-whole (e.g. "$82", "$21.01").
  function fmt(cents) {
    var hasCents = cents % 100 !== 0;
    return '$' + (cents / 100).toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: hasCents ? 2 : 0
    });
  }
  // Hero subtotal: always two decimals (e.g. "$118.00", "$328.99").
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function render(bar, subtotal) {
    var amountEl = bar.querySelector('.upsell-bar-amount');
    var msgEl = bar.querySelector('.upsell-bar-msg');
    if (!subtotal || subtotal <= 0) { bar.hidden = true; return; }   // empty cart -> whole bar hidden
    bar.hidden = false;

    if (amountEl) amountEl.textContent = money(subtotal);   // hero figure; "In cart" caption is static
    if (!msgEl) return;

    var cfg = cfgFor(bar);   // tiers/min from data-* (metafield-driven), with fallback

    // Localized message templates from the section (data-i18n-*); {amount} = the bold figure slot.
    var tMin = bar.getAttribute('data-i18n-min') || 'Add {amount} to reach the $200 minimum';
    var tNext = bar.getAttribute('data-i18n-next') || '{amount} to your next discount';
    var tUnlocked = bar.getAttribute('data-i18n-unlocked') || '✓ Best price unlocked · 6% off your whole order';

    if (subtotal >= cfg.top) {
      // State C — top tier reached: yellow confirmation replaces the gap line.
      msgEl.className = 'upsell-bar-msg upsell-bar-msg--unlocked';
      msgEl.textContent = tUnlocked;
      return;
    }
    msgEl.className = 'upsell-bar-msg';
    if (subtotal < cfg.min) {
      // State A — below the minimum.
      msgEl.innerHTML = tMin.replace('{amount}', '<b>' + fmt(cfg.min - subtotal) + '</b>');
    } else {
      // State B — gap to the next tier above the subtotal.
      var next = cfg.top;
      for (var i = 0; i < cfg.tiers.length; i++) { if (cfg.tiers[i] > subtotal) { next = cfg.tiers[i]; break; } }
      msgEl.innerHTML = tNext.replace('{amount}', '<b>' + fmt(next - subtotal) + '</b>');
    }
  }

  function apply(subtotal) { document.querySelectorAll('.upsell-bar').forEach(function (bar) { render(bar, subtotal); }); }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var s = 0;
        (cart.items || []).forEach(function (it) { s += (it.original_line_price || 0); });
        apply(s);
      })
      .catch(function () {});
  }
  function scheduleRefresh() { if (pending) return; pending = setTimeout(function () { pending = null; refresh(); }, 90); }

  // --- Right column taps to cart (left rotator keeps its own links; separate hit areas) -------
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }
  function wireCartTap() {
    document.querySelectorAll('.upsell-bar-right').forEach(function (el) {
      if (el.__tapWired) return;
      el.__tapWired = true;
      el.addEventListener('click', function () { window.location.href = cartUrl(); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); window.location.href = cartUrl(); }
      });
    });
  }

  // --- LEFT column: hub-and-spoke vertical rotator -------------------------------------------
  // Message 0 is the anchor (WhatsApp); every spoke returns to it. Fast swap (~0.3s), long
  // stillness (10s anchor / 5s spoke). Outgoing slides up and out the top; incoming enters from
  // below. Honors prefers-reduced-motion with a hard swap at the same timings.
  function initRotator(rotator) {
    if (rotator.__rotatorInit) return;
    rotator.__rotatorInit = true;
    var msgs = Array.prototype.slice.call(rotator.querySelectorAll('.msg'));
    if (msgs.length <= 1) return;   // nothing to rotate (anchor only)

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SLIDE = 300;

    // seq: anchor (10s) then each spoke (5s), anchor between every spoke.
    var seq = [];
    for (var i = 1; i < msgs.length; i++) { seq.push({ i: 0, hold: 10000 }); seq.push({ i: i, hold: 5000 }); }

    msgs.forEach(function (m) { m.style.transform = 'translateY(100%)'; });   // park all below
    var current = msgs[0];
    current.style.transition = 'none';
    current.style.transform = 'translateY(0)';                               // show the anchor

    var step = 0, timer = null;
    function schedule(hold) { timer = setTimeout(function () { step = (step + 1) % seq.length; transitionTo(seq[step]); }, hold); }
    function transitionTo(s) {
      var incoming = msgs[s.i];
      if (incoming !== current) {
        if (reduce) {
          current.style.transition = 'none'; current.style.transform = 'translateY(100%)';
          incoming.style.transition = 'none'; incoming.style.transform = 'translateY(0)';
        } else {
          var out = current;
          out.style.transition = 'transform ' + SLIDE + 'ms ease';
          out.style.transform = 'translateY(-100%)';                          // up and out the top
          setTimeout(function () { out.style.transition = 'none'; out.style.transform = 'translateY(100%)'; }, SLIDE);   // reset below for next time
          incoming.style.transition = 'transform ' + SLIDE + 'ms ease';
          incoming.style.transform = 'translateY(0)';                         // in from below
        }
        current = incoming;
      }
      schedule(s.hold + (reduce ? 0 : SLIDE));
    }
    schedule(seq[0].hold);   // hold the anchor, then advance
  }
  function initRotators() { document.querySelectorAll('.msg-rotator').forEach(initRotator); }

  // --- Cart-mutation intercept + listeners ---------------------------------------------------
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (window.fetch && !window.fetch.__upsellBarWrapped) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = (input && input.url) ? input.url : (typeof input === 'string' ? input : '');
      var res = origFetch.apply(this, arguments);
      if (CART_MUTATION.test(url)) { res.then(scheduleRefresh).catch(function () {}); }
      return res;
    };
    window.fetch.__upsellBarWrapped = true;
  }
  if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__upsellBarWrapped) {
    var oOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) { this.__upsellCart = CART_MUTATION.test(url || ''); return oOpen.apply(this, arguments); };
    var oSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () { if (this.__upsellCart) this.addEventListener('load', scheduleRefresh); return oSend.apply(this, arguments); };
    XMLHttpRequest.prototype.__upsellBarWrapped = true;
  }

  function init() { wireCartTap(); initRotators(); refresh(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Belt-and-suspenders: Dawn cart pub/sub, back-nav, section reloads.
  try { if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh); } catch (e) {}
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', function () { wireCartTap(); initRotators(); refresh(); });
})();
